<template>
  <ProSpaceRightPanel
    v-if="ids.length > 0"
    :header="header"
    :loading="loading"
    :has-error="hasError"
    @clear="clearPanel"
    @delete="deletePanel"
    @show-history="showHistoryPanel"
  >
    <template v-if="ids.length === 1" v-slot:center>
      <ProSpacePanelBlock :header="headerDocuments">
        <template v-slot>
          <div class="prospace-panel-block-list">
            <div class="prospace-panel-block-list__row">
              <ProSpacePanelBlockItem
                class="prospace-panel-block-list__item"
                :title="$t('documentOrderAgencyValue')"
                :text="document?.orderAgencyValue"
              />
            </div>
            <div class="prospace-panel-block-list__row">
              <ProSpacePanelBlockItem
                class="prospace-panel-block-list__item"
                :title="$t('documentOrderMarsPeriodName')"
                :text="document?.orderMarsPeriodName"
              />
            </div>
            <div class="prospace-panel-block-list__row">
              <ProSpacePanelBlockItem
                class="prospace-panel-block-list__item"
                :title="$t('documentSize')"
                :text="document?.size"
              />
            </div>
            <div class="prospace-panel-block-list__row">
              <ProSpacePanelBlockItem
                class="prospace-panel-block-list__item"
                :title="$t('documentFileName')"
              >
                <template #content>
                  <ProSpaceVLayout :gap="5">
                    <ProSpaceAction
                      icon-width="14px"
                      icon-height="14px"
                      :text="document?.fileName"
                      @click="$emit('downloadAttachment', document)"
                    />
                  </ProSpaceVLayout>
                </template>
              </ProSpacePanelBlockItem>
            </div>
          </div>
        </template>
      </ProSpacePanelBlock>
    </template>
    <template v-if="ids.length === 1" v-slot:bottom>
      <ProSpacePanelBlock :header="headerBottom">
        <template v-slot>
          <ProSpacePanelBlockList :list="contentBottom" />
        </template>
      </ProSpacePanelBlock>
    </template>
  </ProSpaceRightPanel>
</template>

<script>
import {
  ProSpaceRightPanel,
  ProSpaceTabs,
  ProSpacePanelBlock,
  ProSpacePanelBlockList,
  ProSpacePanelBlockItem,
  ProSpaceVLayout,
  ProSpaceAction,
} from "@prospace/prospace-components-library";
import { DocumentService } from "../../../services/DocumentService";
import { FileService } from "../../../../../../Frontends/ProSpace/services/FileService";
import { mapGetters } from "vuex";
import {getAMorPM} from "@prospace/prospace-components-library/src/lib-assets/mixins/date";
export default {
  name: "DocumentPanel",
  components: {
    ProSpaceRightPanel,
    ProSpaceTabs,
    ProSpacePanelBlock,
    ProSpacePanelBlockList,
    ProSpacePanelBlockItem,
    ProSpaceVLayout,
    ProSpaceAction,
  },
  props: {
    options: {
      type: Array,
      default: () => {
        return [];
      },
    },
    ids: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      document: null,
      documentService: new DocumentService(),
      fileService: new FileService(),
      loading: false,
      hasError: false,
    };
  },
  computed: {
    ...mapGetters({
      userinfo: "userinfoStore/getUserinfo",
      getFormatDateTime: "userinfoStore/getFormatDateTime"
    }),
    headerDocuments() {
      return {
        title: this.$t("overview"),
        isExpand: false,
      };
    },
    headerBottom() {
      return {
        title: this.$t("metaInfTxt"),
        isExpand: true,
      };
    },
    tabs() {
      return [{ name: this.$t("overview"), isActive: true }];
    },
    header() {
      if (this.document) {
        return {
          title:
            this.document.type === "plan"
              ? this.$t("documentPlanTab")
              : this.$t("documentFactTab"),
          id: this.ids[0],
          status: this.getStatus(this.document.type),
          options: this.options,
          showCounter: false,
        };
      }
      return {
        title: this.$t("itemsSelected"),
        counter: this.ids.length,
        showCounter: true,
        cleareble: true,
      };
    },
    contentBottom() {
      if (this.document) {
        return [
          [
            {
              title: this.$t("createdByTxt"),
              text: this.document.createdBy,
            },
            {
              title: this.$t("updatedByTxt"),
              text: this.document.updatedBy,
            },
          ],
          [
            {
              title: this.$t("createdAtTxt"),
              text: this.getFormatDateTime(this.document.createdAt) + ' ' + getAMorPM(this.document.createdAt, this.userinfo?.timeFormat),
            },
            {
              title: this.$t("lastUpdatedTxt"),
              text: this.getFormatDateTime(this.document.lastUpdated) + ' ' + getAMorPM(this.document.lastUpdated, this.userinfo?.timeFormat),
            },
          ],
        ];
      }
      return [];
    },
  },
  mounted() {
    this.update();
  },
  watch: {
    ids() {
      this.update();
    },
  },
  methods: {
    update() {
      this.hasError = false;
      try {
        this.getDocument();
      } catch (e) {
        this.hasError = true;
      }
    },
    getDocument() {
      if (this.ids.length === 1) {
        this.loading = true;
        this.documentService.get(this.ids[0]).then((res) => {
          this.document = res.data;
          this.loading = false;
        });
      }
      this.document = null;
    },
    getStatus(status) {
      if (!status) return;
      return {
        type: status === "plan" ? "info" : "teal",
        text: this.$t(status),
      };
    },
    clearPanel() {
      this.$emit("clear");
    },
    deletePanel() {
      this.$emit("delete", this.document);
    },
    showHistoryPanel() {
      this.$emit("history", this.document);
    },
  },
};
</script>

<style lang="scss" scoped>
.prospace-panel-block-list {
  &__row {
    display: flex;
    column-gap: 10px;
    //border-bottom: 1px dashed var(--libBorder);

    &:last-child {
      border-bottom: none;
    }
    &:not(:first-child) {
      .prospace-panel-block-item {
        padding: 10px 0;
      }
    }
    &:first-child {
      .prospace-panel-block-item {
        padding: 0 0 10px;
      }
    }
  }
}
</style>
